"use client";

import { useState, useEffect } from "react";

export function CheckoutButton({
  url,
  expiresInSeconds,
}: {
  url: string;
  expiresInSeconds: number;
}) {
  const [secondsLeft, setSecondsLeft] = useState(expiresInSeconds);

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft((prev) => Math.max(0, prev - 1));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const expired = secondsLeft === 0;

  return (
    <div className="my-3">
      <div className="bg-[var(--color-accent)]/5 border border-[var(--color-accent)]/30 rounded-xl p-4">
        <div className="flex items-center gap-2 mb-2">
          <span className="font-medium text-sm text-[var(--color-accent)]">Secure Payment via Stripe</span>
        </div>
        <p className="text-xs text-gray-600 mb-3">
          Your payment is processed on Stripe's secure hosted page. We never see your card details.
        </p>
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className={`block text-center px-4 py-3 rounded-lg font-medium text-sm transition-colors min-h-[48px] flex items-center justify-center ${
            expired
              ? "bg-gray-200 text-gray-400 cursor-not-allowed"
              : "bg-[var(--color-accent)] text-white hover:bg-[var(--color-accent-light)]"
          }`}
        >
          {expired ? "Link expired — ask for a new one" : "Pay Now →"}
        </a>
        {!expired && (
          <p className="text-xs text-gray-400 text-center mt-2">
            Link expires in {minutes}:{seconds.toString().padStart(2, "0")}
          </p>
        )}
      </div>
    </div>
  );
}
